module.exports = __webpack_public_path__ + "img/table-link-icon.3af49cbc.svg";